import React, { useContext, useEffect, useState } from "react";
import { Box, Container, Grid, Stack, useMediaQuery } from "@mui/material";

import LiveProjects from "./LiveProjects";
import axios from "axios";
import { AppContext, url } from "../utils";
import logo from "../images/logo.svg";
import ClosedProjects from "../components/ClosedProjects/ClosedProjects";
import { useStakingContractWeb3 } from "../ConnectivityAss/hooks";
import WithdrawalTimer from "./Timer";
import TotalAmountRaised from "./totalAmountRaised";
import Loading from "../loading";

export default function Projects() {
  const matches = useMediaQuery("(max-width:750px)");

  const stakingContractWeb3 = useStakingContractWeb3();

  const [Data, setData] = useState([]);
  const [findData, setfindData] = useState([]);
  const [totalUsers, settotalUsers] = useState(0);
  const [loading, setloading] = useState(false);
  const [projectsLength, setprojectsLength] = useState(0);
  const initData = async () => {
    setloading(true);
    try {
      const { data } = await axios.get(`${url}/presaleRouter/IODData/`);
      setData(data.iod);
      setprojectsLength(data.iod);
      setloading(false);
    } catch (error) {}
    setloading(false);
  };
  const initStakers = async () => {
    setloading(true);
    try {
      const uniqueParticepents = await stakingContractWeb3.methods
        .totalstakers()
        .call();
      settotalUsers(+uniqueParticepents);
      setloading(false);
    } catch (error) {}
    setloading(false);
  };

  useEffect(() => {
    initData();
    initStakers();
  }, []);

  useEffect(() => {
    setloading(true);
    try {
      const init = async () => {
        let findDataServer = await Data.filter(
          ({ projectStatus }) => projectStatus == "upcoming"
        );
        setfindData(findDataServer);
        setloading(false);
      };
      if (Data.length > 0) {
        init();
      }
    } catch (error) {}
    setloading(false);
  }, [Data]);

  return (
    <>
      <Loading loading={loading} />
      <Box pt={matches ? 20 : 25} pb={10}>
        <Container maxWidth="lg">
          <Grid mb={10} container display="flex" alignItems="center">
            <Grid item xs={12} md={4} py={2}>
              <Box fontFamily="Raleway" fontSize="25px" fontWeight="600">
                Funded Projects
              </Box>
              <Box fontFamily="Raleway" color="#717988" fontSize="20px">
                We bring new technologies to our community
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={2.5}
              md={2.5}
              border="1px solid #1E2632"
              borderRadius="5px"
              marginRight={matches ? "0px" : "5px"}
              mb={matches ? 2 : 0}
            >
              <Stack px={2} py={1} direction="row" alignItems="center">
                <Box
                  pb={0.5}
                  pt={1}
                  px={1}
                  borderRadius="100px"
                  style={{
                    background:
                      "linear-gradient(-30deg,#000A19 0%,#0D398E 100%)",
                  }}
                  mr={matches ? 2 : 1}
                >
                  <img width="30px" height="30px" src={logo} alt="" />
                </Box>
                <Box>
                  <Box fontSize="14px" fontFamily="Open Sans">
                    Funded Projects
                  </Box>
                  <Box fontSize="14px" fontFamily="Open Sans">
                    {+projectsLength?.length > 0
                      ? +projectsLength?.length
                      : "0"}
                  </Box>
                </Box>
              </Stack>
            </Grid>
            <Grid
              item
              xs={12}
              sm={2.5}
              md={2.5}
              border="1px solid #1E2632"
              borderRadius="5px"
              marginRight={matches ? "0px" : "5px"}
              mb={matches ? 2 : 0}
            >
              <Stack px={2} py={1.3} direction="row" alignItems="center">
                <Box
                  pb={0.5}
                  pt={1}
                  px={1}
                  borderRadius="100px"
                  style={{
                    background:
                      "linear-gradient(-30deg,#C3B1EE 0%,#ffffff 100%)",
                  }}
                  mr={matches ? 2 : 1}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 6C10.343 6 9 4.657 9 3C9 1.343 10.343 0 12 0C13.657 0 15 1.343 15 3C15 4.657 13.657 6 12 6Z"
                      fill="#0078D7"
                    />
                    <path
                      d="M12 6C10.343 6 9 4.657 9 3C9 1.343 10.343 0 12 0C13.657 0 15 1.343 15 3C15 4.657 13.657 6 12 6Z"
                      fill="white"
                      fillOpacity="0.3"
                    />
                    <path
                      d="M4 19V11C4 9.87 4.391 8.838 5.026 8H2C0.895 8 0 8.895 0 10V16H2V21C2 21.552 2.448 22 3 22H5C5.552 22 6 21.552 6 21V19H4Z"
                      fill="#0078D7"
                    />
                    <path
                      d="M4 19V11C4 9.87 4.391 8.838 5.026 8H2C0.895 8 0 8.895 0 10V16H2V21C2 21.552 2.448 22 3 22H5C5.552 22 6 21.552 6 21V19H4Z"
                      fill="white"
                      fillOpacity="0.3"
                    />
                    <path
                      d="M14 24H10C9.448 24 9 23.552 9 23V17H6V11C6 9.343 7.343 8 9 8H15C16.657 8 18 9.343 18 11V17H15V23C15 23.552 14.552 24 14 24Z"
                      fill="#0078D7"
                    />
                    <path
                      d="M14 24H10C9.448 24 9 23.552 9 23V17H6V11C6 9.343 7.343 8 9 8H15C16.657 8 18 9.343 18 11V17H15V23C15 23.552 14.552 24 14 24Z"
                      fill="white"
                      fillOpacity="0.3"
                    />
                    <path
                      d="M4 7C2.895 7 2 6.105 2 5C2 3.895 2.895 3 4 3C5.105 3 6 3.895 6 5C6 6.105 5.105 7 4 7Z"
                      fill="#0078D7"
                    />
                    <path
                      d="M4 7C2.895 7 2 6.105 2 5C2 3.895 2.895 3 4 3C5.105 3 6 3.895 6 5C6 6.105 5.105 7 4 7Z"
                      fill="white"
                      fillOpacity="0.3"
                    />
                    <path
                      d="M20 19V11C20 9.87 19.609 8.838 18.974 8H22C23.105 8 24 8.895 24 10V16H22V21C22 21.552 21.552 22 21 22H19C18.448 22 18 21.552 18 21V19H20Z"
                      fill="#0078D7"
                    />
                    <path
                      d="M20 19V11C20 9.87 19.609 8.838 18.974 8H22C23.105 8 24 8.895 24 10V16H22V21C22 21.552 21.552 22 21 22H19C18.448 22 18 21.552 18 21V19H20Z"
                      fill="white"
                      fillOpacity="0.3"
                    />
                    <path
                      d="M20 7C21.105 7 22 6.105 22 5C22 3.895 21.105 3 20 3C18.895 3 18 3.895 18 5C18 6.105 18.895 7 20 7Z"
                      fill="#0078D7"
                    />
                    <path
                      d="M20 7C21.105 7 22 6.105 22 5C22 3.895 21.105 3 20 3C18.895 3 18 3.895 18 5C18 6.105 18.895 7 20 7Z"
                      fill="white"
                      fillOpacity="0.3"
                    />
                  </svg>
                </Box>
                <Box>
                  <Box fontSize="14px" fontFamily="Open Sans">
                    Unique Users
                  </Box>
                  <Box fontSize="14px" fontFamily="Open Sans">
                    {totalUsers.toLocaleString()}
                  </Box>
                </Box>
              </Stack>
            </Grid>
            <Grid
              item
              xs={12}
              sm={2.5}
              md={2.5}
              border="1px solid #1E2632"
              borderRadius="5px"
            >
              <Stack px={2} py={1.3} direction="row" alignItems="center">
                <Box
                  pb={0.5}
                  pt={1}
                  px={1}
                  borderRadius="100px"
                  style={{
                    background:
                      "linear-gradient(-30deg,#C3B1EE 0%,#ffffff 100%)",
                  }}
                  mr={matches ? 2 : 1}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z"
                      fill="#0078D7"
                    />
                    <path
                      d="M19 4V1.5C19 0.672 18.328 0 17.5 0C16.672 0 16 0.672 16 1.5V4H15V1.5C15 0.672 14.328 0 13.5 0C12.672 0 12 0.672 12 1.5V4H11V1.5C11 0.672 10.328 0 9.5 0C8.672 0 8 0.672 8 1.5V4H7V1.5C7 0.672 6.328 0 5.5 0C4.672 0 4 0.672 4 1.5V4H0V18H4.262C5.151 21.449 8.273 24 12 24C15.727 24 18.848 21.449 19.738 18H24V16V4H19ZM22 16H20V8C17.791 8 16 9.791 16 12V15C14.992 15 14.083 15.385 13.38 16C12 17.281 11.5 19.031 11.5 19.031C11.5 19.031 10.985 17.731 11.228 16H2V6H22V16Z"
                      fill="#0078D7"
                    />
                  </svg>
                </Box>
                <Box>
                  <Box fontSize="14px" fontFamily="Open Sans">
                    Raised Capital
                  </Box>
                  <Box fontSize="14px" fontFamily="Open Sans">
                    <TotalAmountRaised /> BUSD
                  </Box>
                </Box>
              </Stack>
            </Grid>
          </Grid>
          <Box
            mb={3}
            textAlign="center"
            fontSize="30px"
            fontWeight="700"
            fontFamily="Raleway"
          >
            Upcoming Projects
          </Box>
          <Grid container spacing={5} justifyContent="center">
            {findData.length > 0 ? (
              findData.map((item) => (
                <Grid item xs={12} sm={4}>
                  <Box bgcolor="#271942" borderRadius="15px">
                    <Box
                      position="relative"
                      height="204px"
                      borderRadius="15px"
                      style={{
                        background: `url(${item.coverImage})`,
                        backgroundPosition: "cover",
                        backgroundSize: "100% 100%",
                      }}
                    >
                      <Box
                        position="absolute"
                        top="65%"
                        left="10%"
                        width="93px"
                        height="93px"
                        border="6px solid #1B202C"
                        borderRadius="15px"
                        style={{
                          background: `url(${item.logoLink})`,
                          backgroundPosition: "cover",
                          backgroundSize: "100% 100%",
                        }}
                      ></Box>
                    </Box>
                    <Stack
                      mt={4}
                      mx="auto"
                      direction="row"
                      justifyContent="space-between"
                      width="80%"
                    >
                      <Box
                        fontFamily="Raleway"
                        color="#fff"
                        fontSize="1rem"
                        fontWeight="500"
                      >
                        <Box fontSize="1.5625rem">{item.projectName}</Box>
                        <Box color="#717988">{item.tokenSymbol}</Box>
                      </Box>
                      <Box>
                        <img width="40px" src={item.logoLink} />
                      </Box>
                    </Stack>
                    <Stack
                      mt={2}
                      mx="auto"
                      direction="row"
                      justifyContent="space-between"
                      width="80%"
                      color="#fff"
                      fontSize="15px"
                      fontWeight="500"
                    >
                      <Box fontFamily="Raleway">Presale Price</Box>

                      <Box fontFamily="Open Sans">{item.presaleRate}</Box>
                    </Stack>
                    <Stack
                      mx="auto"
                      mt={1}
                      direction="row"
                      justifyContent="space-between"
                      width="80%"
                      color="#fff"
                      fontSize="15px"
                      fontWeight="500"
                    >
                      <Box fontFamily="Raleway">Project Status</Box>
                      <Box fontFamily="Raleway">{item.projectStatus}</Box>
                    </Stack>
                    <Stack
                      pb={4}
                      mx="auto"
                      mt={1}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      width="80%"
                      color="#fff"
                      fontSize="15px"
                      fontWeight="500"
                    >
                      <Box fontFamily="Raleway">Start Time</Box>

                      <Box fontFamily="Open Sans">
                        <WithdrawalTimer endTime={+item.startTime} />
                      </Box>
                    </Stack>
                  </Box>
                </Grid>
              ))
            ) : loading ? (
              loading
            ) : (
              <Box
                width="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Box
                  mt={5}
                  borderRadius="10px"
                  px={3}
                  py={2}
                  ml={4}
                  boxShadow="rgba(0, 0, 0, 0.35) 0px 0px 15px 5px"
                  fontWeight={500}
                  fontSize="20px"
                  fontFamily="Raleway"
                >
                  There is no Upcoming Project yet
                </Box>
              </Box>
            )}
          </Grid>
        </Container>
        <LiveProjects />
        <ClosedProjects />
      </Box>
    </>
  );
}
